export default __webpack_public_path__ + "static/media/collectible_nft_icon.896a1f5f.svg";